import { useAuthContext } from 'context/AuthContext'
import { useGlobalState } from 'context/GlobalStateContext'
import CIMSSelect from 'components/CIMSSelect'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import { CIMSModule, CIMSPage, pathify } from 'shared'
import { useHistory } from 'react-router-dom'
import { useRouteMatches } from 'hooks/useRouteMatches'

const ProjectSelector: React.FC = () => {
  const {
    state: { projectGlobalId, navKey },
    dispatch: { updateProjectGlobalId, updateNavKey },
  } = useGlobalState()
  const { user } = useAuthContext()
  const { replace } = useHistory()
  const { replaceHistory } = useRouteMatches()

  const options = useOptions({
    items: user?.projects,
    value: 'id',
    label: 'name',
    sort: 'name',
  })
  return (
    <CIMSSelect
      style={{ minWidth: 250 }}
      simple
      options={options}
      virtual
      value={projectGlobalId}
      disabled={!user}
      placeholder="Select a Project"
      onChange={(value) => {
        const projectId = value as string
        updateProjectGlobalId(projectId)
        const home = CIMSModule.Home
        const isHome = navKey === home.id
        if (!projectId) {
          updateNavKey(home.id)
          return replace(pathify(home.pathname))
        } else if (
          isHome ||
          CIMSPage.fromId(navKey)?.module === CIMSModule.Developer
        ) {
          if (!isHome) updateNavKey(home.id)
          return replace(pathify(projectId, home.pathname))
        }
        return replaceHistory({
          key: 'projectId',
          action: 'replace',
          value: projectId,
        })
      }}
    />
  )
}

export default ProjectSelector
